import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import styled from 'react-emotion';
import config from '../../config/website';

import ItemNews from '../components/ItemNews';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Container from '../components/Container';

import History from '../icons/fa-solid/History';
import SlideUp from '../components/ani/SlideUp';

import LinkTagTopic from '../components/LinkTagTopic';

import CenterWrap from '../components/CenterWrap';
import CenterDiv from '../components/CenterDiv';

const DivSVG = styled.div`
  svg {
    width: 40rem;
    height: 40rem;
    opacity: 0.35;
    g {
      fill: ${props => props.theme.colors.cool.dark};
    }
  }
  position: absolute;
  top: -650px;
  left: 100px;
  z-index: 10;
  overflow: hidden;
  max-height: 600px;
  @media (max-width:600px) {
    max-height: 560px;
    left: 20px;
    top: -480px;
    svg { 
      width: 38rem;
      height: 38rem;
  }
`;

const Base = styled.div`
  position: relative;
  margin: 0 auto;
  z-index: 8;
  top: -2rem;
  padding-bottom: 2rem;
  padding-left: 3rem;
  padding-right: 3rem;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-row-gap: 2rem;
  max-width: ${props => props.theme.layout.big};
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    grid-template-columns: 1fr;
  }
`;

const News = ({
  data: {
    allMarkdownRemark: { edges },
  },
}) => (
    <React.Fragment>
      <Helmet title={`News | ${config.siteTitle}`} />
      <Header slim title={`:${'\u00A0'}:${'\u00A0'}NEWS${'\u00A0'}:${'\u00A0'}:`}>
        My Journey / Your Shortcut
    </Header>
      <SlideUp delay={0} toY="90px" fromX="-90px">
        <CenterWrap>
          <CenterDiv>
            <DivSVG>
              <History />
            </DivSVG>
          </CenterDiv>
        </CenterWrap>
      </SlideUp>
      <Container>
        <LinkTagTopic />
        <br />
        <Base>
          {edges.map((post, index) => (
            <ItemNews
              key={post.node.frontmatter.title}
              path={post.node.fields.slug}
              cover={post.node.frontmatter.cover.childImageSharp.sizes}
              title={post.node.frontmatter.title}
              date={post.node.frontmatter.date}
              topic={post.node.frontmatter.topic}
              timeToRead={post.node.timeToRead}
              excerpt={post.node.excerpt}
              tags={post.node.frontmatter.tags}
              teams={post.node.frontmatter.teams}
              delay={index}
            />
          ))}
        </Base>
      </Container>
      <Footer />
    </React.Fragment>
  );

export default News;

News.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array.isRequired,
    }),
  }),
};

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query NewsQuery {
    allMarkdownRemark(
      limit: 1000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { sourceInstanceName: { eq: "posts" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          excerpt(pruneLength: 300)
          timeToRead
          frontmatter {
            title
            date(formatString: "MMM.DD.YYYY", locale: "en")
            topic
            tags
            teams
            cover {
              childImageSharp {
                sizes(maxWidth: 900, quality: 90, traceSVG: { color: "#787878" }) {
                  ...GatsbyImageSharpSizes_withWebp_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/news.jsx